export function getJsonFromBlob(blob: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(JSON.parse(event.target?.result as string));
    reader.onerror = (error) => reject(error.target);
    reader.readAsText(blob);
  });
}
